import React, { useState, useEffect } from 'react';
import { FcGoogle } from 'react-icons/fc';

/**
 * Composant pour afficher les boutons de connexion OAuth
 * Récupère dynamiquement les providers activés depuis le backend
 */
const OAuthButtons = ({ onError }) => {
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProviders();
    }, []);

    const fetchProviders = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/providers`);
            
            if (response.ok) {
                const data = await response.json();
                setProviders(data.providers || []);
            } else {
                console.error('Failed to fetch OAuth providers');
            }
        } catch (error) {
            console.error('Error fetching OAuth providers:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleOAuthLogin = (providerId) => {
        // Redirection vers le backend pour initier le flow OAuth
        window.location.href = `${process.env.REACT_APP_API_URL}/auth/${providerId}`;
    };

    const getProviderIcon = (provider) => {
        if (provider.id === 'google') {
            return <FcGoogle className="text-2xl" aria-hidden="true" />;
        }
        return null;
    };

    const getProviderStyles = (providerId) => {
        const baseStyles = "w-full flex items-center justify-center gap-3 py-3 px-4 rounded-lg font-medium transition-all duration-200 border-2";
        return `${baseStyles} bg-white text-gray-700 border-gray-300 hover:border-gray-400 hover:shadow-md dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:hover:border-gray-500`;
    };

    if (loading) {
        return (
            <div className="space-y-3">
                <div className="h-12 bg-gray-200 dark:bg-gray-700 animate-pulse rounded-lg"></div>
            </div>
        );
    }

    if (providers.length === 0) {
        return null; // Ne rien afficher si aucun provider OAuth n'est configuré
    }

    return (
        <div className="space-y-3">
            {providers.map((provider) => (
                <button
                    key={provider.id}
                    onClick={() => handleOAuthLogin(provider.id)}
                    className={getProviderStyles(provider.id)}
                    type="button"
                >
                    {getProviderIcon(provider)}
                    <span>Continuer avec {provider.name}</span>
                </button>
            ))}
        </div>
    );
};

export default OAuthButtons;
